import PackApi from '../api/pack';

const FETCHING_PACKS = "FETCHING_PACKS",
  FETCHING_PACKS_SUCCESS = "FETCHING_PACKS_SUCCESS",
  FETCHING_PACKS_ERROR = "FETCHING_PACKS_ERROR",
  FETCHING_PACK = "FETCHING_PACK",
  FETCHING_PACK_SUCCESS = "FETCHING_PACK_SUCCESS",
  FETCHING_PACK_ERROR = "FETCHING_PACK_ERROR",
  FETCHING_PACK_BY_SKU = "FETCHING_PACK_BY_SKU",
  FETCHING_PACK_BY_SKU_SUCCESS = "FETCHING_PACK_BY_SKU_SUCCESS",
  FETCHING_PACK_BY_SKU_ERROR = "FETCHING_PACK_BY_SKU_ERROR",
  FETCHING_PACK_AKENEO = "FETCHING_PACK_AKENEO",
  FETCHING_PACK_AKENEO_SUCCESS = "FETCHING_PACK_AKENEO_SUCCESS",
  FETCHING_PACK_AKENEO_ERROR = "FETCHING_PACK_AKENEO_ERROR",
  FETCHING_PACK_FIELDS = "FETCHING_PACK_FIELDS",
  FETCHING_PACK_FIELDS_SUCCESS = "FETCHING_PACK_FIELDS_SUCCESS",
  FETCHING_PACK_FIELDS_ERROR = "FETCHING_PACK_FIELDS_ERROR",
  CREATING_PACK = "CREATING_PACK",
  CREATING_PACK_SUCCESS = "CREATING_PACK_SUCCESS",
  CREATING_PACK_ERROR = "CREATING_PACK_ERROR",
  UPDATING_PACK = "UPDATING_PACK",
  UPDATING_PACK_SUCCESS = "UPDATING_PACK_SUCCESS",
  UPDATING_PACK_ERROR = "UPDATING_PACK_ERROR",
  ACTUALIZAR_PACKS = "ACTUALIZAR_PACKS",
  ACTUALIZAR_PACKS_SUCCESS = "ACTUALIZAR_PACKS_SUCCESS",
  ACTUALIZAR_PACKS_ERROR = "ACTUALIZAR_PACKS_ERROR",
  UPDATING_POINTS = "UPDATING_POINTS",
  UPDATING_POINTS_SUCCESS = "UPDATING_POINTS_SUCCESS",
  UPDATING_POINTS_ERROR = "UPDATING_POINTS_ERROR",
  DELETING_PACK = "DELETING_PACK",
  DELETING_PACK_SUCCESS = "DELETING_PACK_SUCCESS",
  DELETING_PACK_ERROR = "DELETING_PACK_ERROR",
  IMPORTING_ZIPS = "IMPORTING_ZIPS",
  IMPORTING_ZIPS_SUCCESS = "IMPORTING_ZIPS_SUCCESS",
  IMPORTING_ZIPS_ERROR = "IMPORTING_ZIPS_ERROR"
;

export default {
  namespaced: true,
  state: {
    isLoading: false,
    error: null,
    entities: [],
    fieldsets: [],
    selectedEntity: null
  },
  getters: {
    isLoading(state) {
      return state.isLoading;
    },
    hasError(state) {
      return state.error !== null;
    },
    error(state) {
      return state.error;
    },
    hasPacks(state) {
      return state.entities.length > 0;
    },
    entities(state) {
      return state.entities;
    },
    entity(state) {
      return state.selectedEntity;
    },
    fieldsets(state) {
      return state.fieldsets;
    }
  },
  mutations: {
    [FETCHING_PACKS](state) {
      state.isLoading = true;
      state.error = null;
      state.entities = [];
    },
    [FETCHING_PACKS_SUCCESS](state, data) {
      state.isLoading = false;
      state.error = null;
      state.entities = data;
      state.selectedEntity = null;
    },
    [FETCHING_PACKS_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.entities = [];
    },
    [FETCHING_PACK](state) {
      state.isLoading = true;
      state.error = null;
      state.selectedEntity = null;
    },
    [FETCHING_PACK_SUCCESS](state, entity) {
      state.error = null;
      state.selectedEntity = entity;
      state.isLoading = false;
    },
    [FETCHING_PACK_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.selectedEntity = null;
    },
    [FETCHING_PACK_BY_SKU](state) {
      state.isLoading = false;
      state.error = null;
    },
    [FETCHING_PACK_BY_SKU_SUCCESS](state, entity) {
      state.error = null;
      state.isLoading = false;
    },
    [FETCHING_PACK_BY_SKU_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [FETCHING_PACK_AKENEO](state) {
      state.isLoading = false;
      state.error = null;
    },
    [FETCHING_PACK_AKENEO_SUCCESS](state, entity) {
      state.error = null;
      state.isLoading = false;
    },
    [FETCHING_PACK_AKENEO_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [FETCHING_PACK_FIELDS](state) {
      state.isLoading = true;
      state.error = null;
    },
    [FETCHING_PACK_FIELDS_SUCCESS](state, fieldsets) {
      state.error = null;
      state.fieldsets = fieldsets.fieldsets;
      state.isLoading = false;
    },
    [FETCHING_PACK_FIELDS_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.fieldsets = [];
    },
    [CREATING_PACK](state) {
      state.isLoading = true;
      state.error = null;
    },
    [CREATING_PACK_SUCCESS](state, entity) {
      state.isLoading = true;
      state.error = null;
      state.selectedEntity = entity;
    },
    [CREATING_PACK_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
      state.selectedEntity = null;
    },
    [UPDATING_PACK](state) {
      state.isLoading = true;
      state.error = null;
    },
    [UPDATING_PACK_SUCCESS](state, entity) {
      state.isLoading = false;
      state.error = null;
    },
    [UPDATING_PACK_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [ACTUALIZAR_PACKS](state) {
      state.isLoading = true;
      state.error = null;
    },
    [ACTUALIZAR_PACKS_SUCCESS](state, entity) {
      state.isLoading = false;
      state.error = null;
    },
    [ACTUALIZAR_PACKS_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [UPDATING_POINTS](state) {
      state.isLoading = true;
      state.error = null;
    },
    [UPDATING_POINTS_SUCCESS](state, entity) {
      state.isLoading = false;
      state.error = null;
    },
    [UPDATING_POINTS_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [DELETING_PACK](state) {
      state.isLoading = true;
      state.error = null;
    },
    [DELETING_PACK_SUCCESS](state, entity) {
      state.isLoading = false;
      state.error = null;
    },
    [DELETING_PACK_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
    },
    [IMPORTING_ZIPS](state) {
      state.isLoading = true;
      state.error = null;
    },
    [IMPORTING_ZIPS_SUCCESS](state, entity) {
      state.isLoading = false;
      state.error = null;
    },
    [IMPORTING_ZIPS_ERROR](state, error) {
      state.isLoading = false;
      state.error = error;
    },
  },
  actions: {
    async findAll({commit}) {
      commit(FETCHING_PACKS);
      try {
        let response = await PackApi.findAll();
        commit(FETCHING_PACKS_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PACKS_ERROR, error);
        return null;
      }
    },
    async find({commit}, id) {
      commit(FETCHING_PACK);
      try {
        let response = await PackApi.find(id);
        commit(FETCHING_PACK_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PACK_ERROR, error);
        return null;
      }
    },
    async findSku({commit}, sku) {
      commit(FETCHING_PACK_BY_SKU);
      try {
        let response = await PackApi.findSku(sku);
        commit(FETCHING_PACK_BY_SKU_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PACK_BY_SKU_ERROR, error);
        return null;
      }
    },
    async findAkeneo({commit}, sku) {
      commit(FETCHING_PACK_AKENEO);
      try {
        let response = await PackApi.findAkeneo(sku);
        commit(FETCHING_PACK_AKENEO_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PACK_AKENEO_ERROR, error);
        return null;
      }
    },
    async findFrontal({commit}, pack_code) {
      commit(FETCHING_PACK);
      try {
        let response = await PackApi.findFrontal(pack_code);
        commit(FETCHING_PACK_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PACK_ERROR, error);
        return null;
      }
    },
    async getFields({commit}) {
      commit(FETCHING_PACK_FIELDS);
      try {
        let response = await PackApi.getFields();
        commit(FETCHING_PACK_FIELDS_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(FETCHING_PACK_FIELDS_ERROR, error);
        return null;
      }
    },
    async create({commit}, params) {
      commit(CREATING_PACK);
      try {
        let response = await PackApi.create(params);
        if (response.isAxiosError) {
          throw response;
        }
        commit(CREATING_PACK_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(CREATING_PACK_ERROR, error);
        return null;
      }
    },
    async update({commit}, params) {
      commit(UPDATING_PACK);
      try {
        let response = await PackApi.update(params);
        if (response.isAxiosError) {
          throw response;
        }
        commit(UPDATING_PACK_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(UPDATING_PACK_ERROR, error);
        return null;
      }
    },
    async importarZips({commit}, params) {
      commit(IMPORTING_ZIPS);
      try {
        const response = await PackApi.triggerMassiveZipImport();
        if (response.isAxiosError) {
          throw response;
        }
        commit(IMPORTING_ZIPS_SUCCESS);
        return true;
      } catch (e) {
        commit(IMPORTING_ZIPS_ERROR, e)
        return false;
      }
    },
    async actualizar({commit}, params) {
      commit(ACTUALIZAR_PACKS);
      try {
        let response = await PackApi.actualizar(params);
        if (response.isAxiosError) {
          throw response;
        }
        commit(ACTUALIZAR_PACKS_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(ACTUALIZAR_PACKS_ERROR, error);
        return null;
      }
    },
    async updatePoints({commit}, params) {
      commit(UPDATING_POINTS);
      try {
        let response = await PackApi.updatePoints(params);
        commit(UPDATING_POINTS_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(UPDATING_POINTS_ERROR, error);
        return null;
      }
    },
    async delete({commit}, id) {
      commit(DELETING_PACK);
      try {
        let response = await PackApi.delete(id);
        commit(DELETING_PACK_SUCCESS, response.data);
        return response.data;
      } catch (error) {
        commit(DELETING_PACK_ERROR, error);
        return null;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/pack.js